import ScalarIconArrowLeft_vue_vue_type_script_setup_true_lang_default from "./ScalarIconArrowLeft.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconArrowLeft.vue
var ScalarIconArrowLeft_default = ScalarIconArrowLeft_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconArrowLeft_default as default };

//# sourceMappingURL=ScalarIconArrowLeft.js.map